class FeaturedReviewsCarousel extends HTMLElement {
    constructor() {
      super();
    }

    setVariables() {
      this.sliderElement = this.querySelector('[data-slider]');
      this.slides = this.sliderElement?.querySelectorAll('[data-slider-item]') || [];
      this.prevButton = this.querySelector('[data-slider-prev]')
      this.nextButton = this.querySelector('[data-slider-next]')
    }

    connectedCallback() {
      this.setVariables()
      document.addEventListener('DOMContentLoaded', () => this.initSlider());
      window.addEventListener('resize', () => this.initSlider());
    }

    disconnectedCallback() {
      this.destroySlider();
    }

    initSlider() {
      this.destroySlider();
      if (this.slides.length < 3 || !this.sliderElement) return;

      this.flickity = new Flickity(this.sliderElement, {
        accessibility: true,
        prevNextButtons: false,
        pageDots: false,
        cellAlign: 'left',
        groupCells: 3,
        wrapAround: false,
        groupCells: true,
        freeScroll: false,
        contain: true
      });

      if (this.prevButton) this.prevButton.addEventListener('click', () => this.flickity.previous());
      if (this.nextButton) this.nextButton.addEventListener('click', () => this.flickity.next());

      this.validateCarousel(0)
      this.flickity.on('change', (index) => {
        this.validateCarousel(index)
      })
    }

    validateCarousel(index) {
      if (index == 0) {
        this.prevButton?.classList.add('disabled')
      } else {
        this.prevButton?.classList.remove('disabled')
      }

      if (index >= this.flickity.slides.length - 1) {
        this.nextButton?.classList.add('disabled')
      } else {
        this.nextButton?.classList.remove('disabled')
      }
    }

    destroySlider() {
      if (this.flickity) {
        this.flickity.destroy();
        this.flickity = null;
      }

      if (this.sliderElement) this.sliderElement.classList.remove('flickity-enabled', 'flickity-rtl');
    }
  }

  customElements.define('featured-reviews-carousel', FeaturedReviewsCarousel);
